import { MessageCircle } from 'lucide-react';
import { showIntercom } from '../lib/intercom';
import '@styles/pages/contact.css';

export default function Contact() {
  return (
    <div className="contact-container">
      <div className="contact-card">
        <h1>Contact us</h1>

        <p className="contact-subtitle">
          Questions about a case, your plan or the app? Message us here, or
          email if that's easier.
        </p>

        <button type="button" className="ml-btn ml-btn--ink contact-chat" onClick={() => showIntercom()}>
          <MessageCircle size={16} /> Message us
        </button>

        <div className="contact-box">
          <div className="contact-row">
            <strong>Email</strong>
            <a href="mailto:help@mediloop.ai">help@mediloop.ai</a>
          </div>

          <div className="contact-row">
            <strong>Response time</strong>
            <span>Within 24 hours on business days</span>
          </div>
        </div>

        <p className="contact-note">
          If it's about a case, tell us which one so we can find it straight away.
        </p>
      </div>
    </div>
  );
}
